<script setup lang="ts">
import { useNotifications } from "@shopware-pwa/composables-next";
import useMainNavigationState from "~/composables/useMainNavigationState";
import PageHeader from "~/templates/partials/PageHeader.vue";
import PageFooter from "~/templates/partials/PageFooter.vue";
import PageNotifications from "~/templates/partials/PageNotifications.vue";
import { isComponentPreview } from "~/utils/content/magnolia";

const isPreview = isComponentPreview();

const { isDesktop } = useDevice();
const { isMenuOpen } = useMainNavigationState();

useNotifications();
</script>

<template>
  <slot v-if="isPreview" />
  <div v-else class="flex h-full min-h-screen w-full flex-col items-center">
    <div
      v-if="isDesktop"
      class="fixed z-40 bg-black bg-opacity-75 opacity-0 motion-safe:transition-opacity"
      :class="{
        'opacity-100': isMenuOpen,
        invisible: !isMenuOpen,
        'pointer-events-none': !isMenuOpen,
        'inset-0': isMenuOpen,
      }"
    />
    <PageHeader class="print:hidden" />
    <main id="main" class="w-full flex-1 overflow-x-clip">
      <PageNotifications />
      <slot />
    </main>
    <PageFooter />
  </div>
</template>
